const axios = require('axios');

(() => {
  const selectedCoupon = '.selected-coupon-js'
  const notUseCoupon = '.not-use-barbecue-user-coupon-js';

  var mql = window.matchMedia('screen and (max-width: 915px)');

  const init = () => {
    if (location.pathname !== process.env.JS_BASE_URL + 'customer/barbecue/guest/new') {
      return
    }

    mql.addListener(fetchBarbecueReservationObj);
    $('body')
      .on('click', selectedCoupon, changePrice)
      .on('click', notUseCoupon, removeCoupon);
  }
  const fetchBarbecueReservationObj = () => {
    if (mql.matches) {
      axios.get(process.env.JS_BASE_URL + 'customer/barbecue/guest/fetch_session')
      .then(response => {
        $('.right_panel_block').html(response['data']);
      })
      .catch(error => {
        console.log(error);
        return error;
      })
    } else {
      axios.get(process.env.JS_BASE_URL + 'customer/barbecue/guest/fetch_session')
      .then(response => {
        $('.user-input-right').html(response['data']);
      })
      .catch(error => {
        console.log(error);
        return error;
      })
    }
  }
  const changePrice = e => {
    const $element = $(e.currentTarget);
    const couponId = $element[0].value;
    const token = $('meta[name="csrf-token"]').attr('content');
    axios({
      url: process.env.JS_BASE_URL + 'customer/barbecue/guest/change',
      method: 'POST',
      data: { coupon_id: couponId },
      withCredentials: true,
      headers: { 'X-CSRF-Token': token }
    })
    .then(response => {
      if ( $(window).width() > 915 ) {
        $('.user-input-right').html(response['data']);
      } else {
        $('.right_panel_block').html(response['data']);
      }
    })
    .catch(error => {
      console.log(error);
      return error;
    })
  }

  const removeCoupon = () => {
    const token = $('meta[name="csrf-token"]').attr('content');
    axios({
      url: process.env.JS_BASE_URL + 'customer/barbecue/guest/remove_coupon',
      method: 'DELETE',
      withCredentials: true,
      headers: { 'X-CSRF-Token': token }
    })
    .then(response => {
      if ( $(window).width() > 915 ) {
        $('.user-input-right').html(response['data']);
      } else {
        $('.right_panel_block').html(response['data']);
      }
    })
    .catch(error => {
      console.log(error);
      return error;
    })
  }
  $(init);
})();

